import RootState from '../../rootState';
import Workflow from '../../../models/workflow';

export class Action {
    type!: string;
    registrationId: string;
    sessionId: string;
    userInfo: string; //json string
    workflow: Workflow;
    checkRetry: boolean;
    providerInformationPayment: string;
}

export interface State {
    registrationId: string;
    sessionId: string;
    userInfo: string;
    workflow: Workflow;
    checkRetry: boolean;
}

export const types = {
    ACTION_SERVER_DATA_REQUESTED: 'ACTION_SERVER_DATA_REQUESTED',
    ACTION_SERVER_DATA_FAILED: 'ACTION_SERVER_DATA_FAILED',

    STORE_REGISTRATION_ID: 'STORE_REGISTRATION_ID',
    STORE_SESSION_ID: 'STORE_SESSION_ID',
    STORE_USER_INFOR: 'STORE_USER_INFOR',
    STORE_WORKFLOW_DATA: 'STORE_WORKFLOW_DATA',
    CHECK_RETRY: 'CHECK_RETRY',
};

const baseAction = new Action();

export const actions = {
    actionServerDataRequested: (): Action => ({
        ...baseAction,
        type: types.ACTION_SERVER_DATA_REQUESTED
    }),

    actionServerDataFailed: (): Action => ({
        ...baseAction,
        type: types.ACTION_SERVER_DATA_FAILED
    }),

    storeWorkingRegistrationId: (registrationId: string): Action => ({
        ...baseAction,
        type: types.STORE_REGISTRATION_ID,
        registrationId
    }),

    storeExperianSessionId: (sessionId: string): Action => ({
        ...baseAction,
        type: types.STORE_SESSION_ID,
        sessionId
    }),

    storeUserInfo: (userInfo: string): Action => ({
        ...baseAction,
        type: types.STORE_USER_INFOR,
        userInfo
    }),

    storeWorkflowData: (workflow: Workflow): Action => ({
        ...baseAction,
        type: types.STORE_WORKFLOW_DATA,
        workflow
    }),

    checkRetry: (checkRetry: boolean): Action => ({
        ...baseAction,
        type: types.CHECK_RETRY,
        checkRetry
    }),
};

export const selectors = {
    getState: (rootState: RootState): State => rootState.entities.workflowData,

    getRegistrationId(rootState: RootState): string {
        const { registrationId } = this.getState(rootState);
        return registrationId;
    },

    getSessionId(rootState: RootState): string {
        const { sessionId } = this.getState(rootState);
        return sessionId;
    },

    getUserInfo(rootState: RootState): string {
        const { userInfo } = this.getState(rootState);
        return userInfo;
    },

    getWorkflow(rootState: RootState): Workflow {
        const { workflow } = this.getState(rootState);
        return workflow;
    },

    checkRetry(rootState: RootState): boolean {
        const { checkRetry } = this.getState(rootState);
        return checkRetry;
    }
};


// WEBPACK FOOTER //
// ./src/modules/entities/workflow/index.ts